__turbopack_context__.v({
  "eds-example-grid-coloring": "EventCard-module-scss-module__Jf79Ra__eds-example-grid-coloring",
  "eds-example-grid-content": "EventCard-module-scss-module__Jf79Ra__eds-example-grid-content",
  "eds-example-sidebar-content": "EventCard-module-scss-module__Jf79Ra__eds-example-sidebar-content",
  "eds-g-cell": "EventCard-module-scss-module__Jf79Ra__eds-g-cell",
  "eds-g-sidebar": "EventCard-module-scss-module__Jf79Ra__eds-g-sidebar",
  "eds-g-view": "EventCard-module-scss-module__Jf79Ra__eds-g-view",
  "feedCardCell": "EventCard-module-scss-module__Jf79Ra__feedCardCell",
});
